export default {
  login: (username, password)=>{
    const usernames = ['tma','doctor', 'admin', 'csr']
    if ( password !== '12345')
      return false
    if ( !usernames.includes(username) )
      return false
    else
      return {
        "user": {  
          "id": 85,
          "username": "robcastillo123",
          "email": "castillolianrobin@gmail.com",
          "has_2fa": 0,
          "is_locked": 0,
          "is_active": 1,
          "google_id": "",
          "insurance_number": null,
          "insurance_provider": null,
          "user_type": username,
          "created_at": "2020-10-05 06:40:16",
          "updated_at": "2020-10-05 06:40:16",
          "deleted_at": null,
          "device_token": null,
          "tma": {
            "id": 4,
            "first_name": "Juan",
            "middle_name": "D",
            "last_name": "Cruz",
            "nickname": "john",
            "profile_image": "",
            "mobile_number": "09997576345",
            "phone_number": "12345",
            "email": "castillolianrobin@gmail.com",
            "address": "Langka St., Comembo, Makati City",
            "user_id": 85,
            "created_at": "2020-10-05 06:40:16",
            "updated_at": "2020-10-05 06:40:16",
            "deleted_at": null
          },
          "doctor": {
              "id": 4,
              "first_name": "Juan",
              "middle_name": "D",
              "last_name": "Cruz",
              "nickname": "johny",
              "profile_image": "",
              "mobile_number": "09997576345",
              "phone_number": "12345",
              "email": "castillolianrobin@gmail.com",
              "address": "Langka St., Comembo, Makati City",
              "user_id": 85,
              "created_at": "2020-10-05 06:40:16",
              "updated_at": "2020-10-05 06:40:16",
              "deleted_at": null
          },
          "patient": null
        },
        "token": {
          "accessToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMDgwNmNhZDI0YTMyYTM5M2Y0MTIwOTk0MDVjYzA4ODY0YjVjY2FlYzBmOGVlYjk2NzQzNmY1YjUzZjY3NWQ3MWQzMzYwODZmZjY0OTIyNmIiLCJpYXQiOjE2MDczMTM4NjAsIm5iZiI6MTYwNzMxMzg2MCwiZXhwIjoxNjM4ODQ5ODYwLCJzdWIiOiIxMDUiLCJzY29wZXMiOltdfQ.AHggLRgA8VyEFUb_oPPRez7qHLm62sC8uC3MumBDEuwbeuM3xeDO1bx1R9t8ZAKFGI_BqbLsjYxREyr1b3F4Ai8o25vT-LpuAlTxLI3uQJtUd08BnP_MhOMIgKDsmGofn-IdyBMLrHKYJsxBTnmHb6Gph2q5e2weIxgToZklOYRqhl7aQFZxw451Qe7AaCpKniN2UrK23Gj2TSE4iz0KbDrdF7xdv9EQ9zEg7lpX8QPpdKIMs-vYT9Q8HvFRtKOlY6kd6Ou0M9A9K1dkV3I8qb_fjfIgq7tjqFdM8ySXdcodRI-7o62jDM4vgNkREXkfu_cSzTzaVazvoH-x3k49EjM6l46oFuma9TFrxGR658ZSv4On0LuhMcdI4Cxq6ALTBaW4GBchwXRfhCAYZZCyI9k_D2N1iQ7s2u6qsIWHwwlZs_IOfXFR1LJG3DKW2xLrHkVVNiN_vYMUI6rSxVzQo4AUR4dforUOuPcRG6xbRmuoR3-Hejd7f4GQ97OFnxuIIRBVQCMNFwxKm73JGgcUAIyRLaW6Ao_D0Cy3582KY7ZwyfD9HdsNHkF8nqnFV4QRDN0Khnh1AOBNSI-0o1V1Hqj-Fe8tSE8PpJo3hxKmB0M12VoCFNG4ff7XBq8gmNECK3pENlteEFzVikVl2z9VVN6XqjfW9Bw25uGxhI1csvo",
          "token": {
              "id": "e62843fc38997f2fe661c1e40e6d25a1efe92cd606391a2bb7a91215793302bf67cf9b29d2aeb7c2",
              "user_id": 85,
              "client_id": 1,
              "name": "expee",
              "scopes": [],
              "revoked": false,
              "created_at": "2020-10-30 04:20:32",
              "updated_at": "2020-10-30 04:20:32",
              "expires_at": "2021-10-30 04:20:32"
          }
        }
    }
  },
  
}